import { render, staticRenderFns } from "./FilterSliderComponent.vue?vue&type=template&id=bc816840&scoped=true&"
import script from "./FilterSliderComponent.vue?vue&type=script&lang=js&"
export * from "./FilterSliderComponent.vue?vue&type=script&lang=js&"
import style0 from "./FilterSliderComponent.vue?vue&type=style&index=0&id=bc816840&prod&scoped=true&lang=scss&"
import style1 from "./FilterSliderComponent.vue?vue&type=style&index=1&id=bc816840&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc816840",
  null
  
)

export default component.exports